import styles from "./style.module.scss";
import { PostType } from "@components/severalbrands/gqlQueries";
import Image from "next/image";
import Tooltip from "@components/severalbrands/tooltip";
import Link from "next/link";
import { useState } from "react";
import CloseIcon from "./closeIcon";
import UpArrow from "./UpArrow";
import { motion, AnimatePresence } from "framer-motion";
import { replacePlaceholders } from "@lib/sharedUtils";
export default function SideWidget({
    titlesList,
    allPosts,
}: {
    titlesList: { title: string | null; link: string }[];
    allPosts: PostType[];
}) {
    const [contentOpen, setContentOpen] = useState(true);
    const [modalVisibility, setModalVisibility] = useState(false);

    return (
        <section className="3xl:w-[586px] lg:w-[386px] relative h-[800px] lg:h-fit  lg:sticky lg:top-28 ">
            {titlesList.length > 0 && (
                <div
                    className={`${
                        styles["contentsContainer"]
                    } mb-8 hidden lg:block  ${
                        contentOpen ? "pt-12 pb-16" : "py-4 3xl:py-6"
                    } px-9 3xl:px-12 `}
                >
                    <div className=" flex justify-between items-center ">
                        <h3
                            className={`3xl:text-3xl  lg:text-xl text-lg font-semibold`}
                        >
                            Content
                        </h3>
                        <motion.span
                            animate={{ rotate: contentOpen ? 0 : 180 }}
                            className="block  cursor-pointer relative w-[40px] h-[20px] p-1 3xl:w-[44px] 3xl:h-[22px]"
                            onClick={() => {
                                setContentOpen((prev) => !prev);
                            }}
                        >
                            <UpArrow />
                        </motion.span>
                    </div>
                    <AnimatePresence>
                        {contentOpen && (
                            <motion.div
                                initial={{ height: 0 }}
                                animate={{ height: "auto" }}
                                exit={{ height: 0 }}
                                className={`${styles["linksList"]}  `}
                            >
                                {titlesList?.map((title, index) => (
                                    <div
                                        key={index}
                                        className={`${styles["bulletedListItem"]}`}
                                    >
                                        <a
                                            href={title?.link ?? "#"}
                                            dangerouslySetInnerHTML={{
                                                __html: title?.title as string,
                                            }}
                                            className={`   block  cursor-pointer 3xl:text-2xl 3xl:leading-10 lg:text-lg text-base hover:underline `}
                                        />
                                    </div>
                                ))}
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            )}
            {modalVisibility ? (
                <div
                    className={`${styles["contentsContainerList"]} ${styles["fixedStyle"]}  `}
                >
                    <div className="flex items-center justify-between">
                        <h3
                            className={`lg:text-xl text-lg font-semibold  w-full text-center`}
                        >
                            Content
                        </h3>
                        <span
                            className="block w-fit p-1 cursor-pointer"
                            onClick={() => {
                                setModalVisibility(false);
                            }}
                        >
                            <CloseIcon />
                        </span>
                    </div>

                    <div className={`${styles["linksList"]}  `}>
                        {titlesList?.map((title, index) => (
                            <div
                                key={index}
                                className={`${styles["bulletedListItem"]}`}
                            >
                                <a
                                    href={title?.link ?? "#"}
                                    dangerouslySetInnerHTML={{
                                        __html: title?.title as string,
                                    }}
                                    className={`   block  cursor-pointer lg:text-lg text-base `}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div
                    className={`lg:hidden font-semibold py-4 px-[131px] rounded-[10px] bg-[#351C4f] text-white  text-center text-xl  ${styles["fixedStyle"]}   `}
                    onClick={() => {
                        setModalVisibility(true);
                    }}
                >
                    Content
                </div>
            )}
            <div
                className={`lg:bg-[#f5f5f5] lg:px-[35px] lg:pt-[50px] lg:pb-[65px]  rounded-[10px] `}
            >
                <h3
                    className={`3xl:text-3xl  lg:text-xl text-3xl font-semibold text-center lg:text-left`}
                >
                    Must Read
                </h3>

                <div className={` mt-6 `}>
                    {allPosts?.map((post, index) => (
                        <Link
                            key={index}
                            href={
                                post.url.isMain
                                    ? post.url.url
                                    : post.url.main.url
                            }
                        >
                            <div
                                className={`bg-[#f5f5f5] lg:bg-transparent lg:mt-8 mt-3 first-of-type:mt-0 flex gap-[14px] rounded-[10px] lg:rounded-none p-[18px] lg:p-0 ${styles["mustReadLinks"]}`}
                            >
                                <div className="relative w-[119px] lg:h-[75px] h-[84px] 3xl:w-[180px] 3xl:h-[110px] ">
                                    <Image
                                        src={
                                            post.image
                                                ? post.image.fullPath
                                                : "/severalbrands/assets/images/placeHolder.png"
                                        }
                                        layout="fill"
                                        objectFit="contain"
                                        alt={replacePlaceholders(post.title, {
                                            category:
                                                post.category.label ??
                                                post.category.name,
                                        })}
                                    />
                                </div>
                                <div>
                                    <Tooltip
                                        tooltipMessage={replacePlaceholders(
                                            post.title,
                                            {
                                                category:
                                                    post.category.label ??
                                                    post.category.name,
                                            },
                                        )}
                                    >
                                        <h4
                                            className={`mt-1 3xl:text-2xl text-lg ${styles["ellipsis-container"]}  `}
                                        >
                                            {replacePlaceholders(post.title, {
                                                category:
                                                    post.category.label ??
                                                    post.category.name,
                                            })}
                                        </h4>
                                    </Tooltip>

                                    <div
                                        className={`3xl:text-xl 3xl:mt-6 mt-3 block text-[#818181] ${styles["readMoreLink"]}  `}
                                    >
                                        Read More
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
